import styled from "@emotion/styled";

export const CounterCard = styled.div`
  width: 100%;
  min-width: 0;
  border-radius: 10px;
  padding: 14px 16px;
  box-sizing: border-box;
`;

export const CounterLabel = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  opacity: 0.95;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CounterValue = styled.div`
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};

    width: fit-content;
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 6px;
    background: rgba(41, 56, 77, 0.55);
    box-sizing: border-box;
`;
